export default __webpack_public_path__ + "static/media/multiple-user-white.2102824e.svg";